// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx Actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setReportDescription } from './description.action';
export const description = createReducer('', on(setCustomPDFReportBuilderStore, setReportDescription, (state, action) => {
    return action.description;
}));
